<template>
  <div>
    <LoadingDialog v-model="showLoadingDialog" />
    <SuccessDialog />
    <CustomerSupport />
    <div class="dashboard-header">
      Manage Your Account
    </div>
    <v-container fluid grid-list-md>
      <v-layout align-start justify-space-between fill-height wrap>

        <!--     Column 1     -->
        <v-flex d-flex xs12 sm6 md4 lg3 xl3>
          <v-layout column>
            <DeclinedPaymentCard />
            <ActivateYourAccountCard />
            <v-flex d-flex>
                <NextPaymentCard />
            </v-flex>
          </v-layout>
        </v-flex>


        <!--     Column 2     -->
        <v-flex d-flex xs12 sm6 md4 lg3 xl3>
          <v-layout column>
            <v-flex d-flex>
              <!--     Your Plan Card     -->
              <div class="dash-card-padding">
                <YourPlanCard />
              </div>
            </v-flex>
            <v-flex d-flex>
              <div class="dash-card-padding">
                <PaymentInformationCard />
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <!--     Column 3     -->
        <v-flex d-flex xs12 sm6 md4 lg3 xl3>
          <v-layout column>
            <v-flex d-flex>
              <!--     Your Account Card     -->
              <div class="dash-card-padding">
                <YourAccountCard />
              </div>
            </v-flex>
            <v-flex v-if="!isAppView" d-flex>
              <!--     Clients Card     -->
              <div class="dash-card-padding">
                <ClientsCard />
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <!--     Column 4     -->
        <v-flex d-flex xs12 sm6 md4 lg3 xl3>
          <v-layout column>
            <v-flex d-flex>
              <!--     Notifications     -->
              <div class="dash-card-padding">
                <NotificationsCard />
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

<!--    empty flex to take up space on the right on xl screens    -->
        <v-flex xs12 xl1 />

      </v-layout>
    </v-container>
  </div>
</template>

<style lang="scss">
  .card-header-bar {
    height: 35px;
    background-color: gray;
  }

  /* we want some padding on "large" screen sizes (950px - 1900px) only */
  @media screen and (min-width: 950px) and (max-width: 1900px) {
    .dash-card-padding {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  .dashboard-header {
    color: #0E4457;
    font-size: 30px;
    font-weight: bold;
    margin: 24px 0 0 36px;
  }

  .dashboard-header-card {
    border-radius: 0;
  }

  .dashboard-h1 {
    color: white;
    font-family: 'IBM Plex Serif', serif;
    font-weight: 400;
    font-size: 32pt;
    text-align: left;
  }
  @media screen and (max-width: 600px) {
    .dashboard-h1 {
      font-size: 17pt;
    }
  }

  .card-header-text {
    color: white;
    padding-left: 15px;
  }

  .card-border {
    border-radius: 10px;
  }

  div.card-body {
    padding: 25px;
    text-align: left;
  }

  .next-payment-price {
    font-size: 23pt;
  }
  .declined-payment-price {
    font-size: 23pt;
    color: red;
  }

  .sm-lbl {
    font-size: 8pt;
    color: gray;
  }

  .txt-bold {
    font-weight: bold;
  }
</style>

<script>
  import auth from '../auth'
  import store from "@/store"
  import LoadingDialog from "../components/LoadingDialog"
  import SuccessDialog from "../components/SuccessDialog"
  import CustomerSupport from "@/components/CustomerSupport";
  import ClientsCard from "../components/dashboard/clientsCard/ClientsCard"
  import DeclinedPaymentCard from "../components/dashboard/DeclinedPaymentCard"
  import NextPaymentCard from "../components/dashboard/nextPaymentCard/NextPaymentCard"
  import YourPlanCard from "../components/dashboard/yourPlanCard/YourPlanCard"
  import PaymentInformationCard from "../components/dashboard/paymentInformationCard/PaymentInformationCard"
  import YourAccountCard from "../components/dashboard/yourAccountCard/YourAccountCard"
  import NotificationsCard from "../components/dashboard/notificationsCard/NotificationsCard"
  import ActivateYourAccountCard from "../components/dashboard/ActivateYourAccountCard"
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    components: {
      LoadingDialog,
      SuccessDialog,
      CustomerSupport,
      DeclinedPaymentCard,
      NextPaymentCard,
      YourPlanCard,
      PaymentInformationCard,
      YourAccountCard,
      NotificationsCard,
      ClientsCard,
      ActivateYourAccountCard,
    },
    mixins: [subscribeToStore],
    data: () => ({
      isAppView: store.state.isAppView,
      showLoadingDialog: false
    }),
    mounted() {
      this.subscribeToStore(['isAppView']);
      this.isAppViewCheck();
      this.getUrlParams();
    },
    methods: {
      isAppViewCheck() {
        const isLoggedIn = auth.loggedIn();
        const isAppView = this.$route.query.hasOwnProperty('apptoken');
        if(isLoggedIn && isAppView) store.commit('setIsAppView', true);
      },
      getUrlParams() {
        this.$store.commit("setInitialUrlParameters", this.$route.query);
      }
    }
  }
</script>
